import Perfil from "@/model/Perfil";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/Perfil/listar?orderBy=1 desc`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId: number) => {
        const response = await httpClient.get(`/Perfil/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (perfil: Perfil) => {
        const response = await httpClient.post(`/Perfil/inserir`, perfil);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (perfil: Perfil) => {
        const response = await httpClient.post(`Perfil/alterar`, perfil);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId: number) => {
        const response = await httpClient.post(`Perfil/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});